// extracted by mini-css-extract-plugin
module.exports = {"card-share-toggle":"card-share_card-share-toggle__2-qYy"};